import Skeleton from "./Skeleton";

export default function FormSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      <Skeleton size="3xl" className="w-28" />
      <div className="flex flex-col gap-1">
        <Skeleton size="xl" className="w-56" />
        <Skeleton size="sm" className="w-full max-w-sm" />
      </div>
      <div className="grid grid-cols-3">
        <Skeleton size="sm" className="w-40" fixed={false} />
        <div>
          <Skeleton size="sm" className="w-32" fixed={false} />
          <div className="flex justify-between rounded-lg bg-gray-50 p-2">
            <div className="h-[72px] w-[72px] rounded-full bg-gray-200" />
            <div className="flex gap-2">
              <Skeleton size="sm" className="w-[78px]" fixed={false} />
              <Skeleton size="sm" className="w-[78px]" fixed={false} />
            </div>
          </div>
        </div>
      </div>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <div key={i} className="grid grid-cols-3">
          <div />
          <div>
            <Skeleton size="sm" className="w-32" fixed={false} />
            <div className="flex flex-col gap-1">
              <Skeleton size="2xl" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
